import { Navigate, Route, Routes } from "react-router-dom";

import { Error } from "../pages";
import { getToken } from "../utils/tokenStorage";
import {
  AddJobs,
  AllJobs,
  AllPostJobs,
  ContactUs,
  EngineeringJobs,
  PostJob,
  Profile,
  SaveForLaterPage,
  SharedLayout,
  SinglePostJobPage,
  Stat,
  StatusBasedJobs,
} from "./protectedRoutes";
import { JobPostsHeader } from "../components/allPostjobs";

const ProtectedRoute = () => {
  const authToken = getToken();

  if (!authToken) {
    return <Navigate to="/" />;
  }

  return (
    <Routes>
      <Route path="/" element={<SharedLayout />}>
        <Route index element={<Stat />} />
        <Route path="pending" element={<StatusBasedJobs />} />
        <Route path="interview" element={<StatusBasedJobs />} />
        <Route path="decline" element={<StatusBasedJobs />} />
        <Route path="all-jobs" element={<AllJobs />} />
        <Route path="add-job" element={<AddJobs />} />
        <Route path="profile" element={<Profile />} />
        <Route path="contact" element={<ContactUs />} />
        <Route path="save-for-later" element={<SaveForLaterPage />} />

        <Route path="post-job" element={<PostJob />} />

        <Route path="all-post-jobs" element={<JobPostsHeader />}>
          <Route index element={<AllPostJobs />} />
          <Route path="engineering-jobs" element={<EngineeringJobs />} />
        </Route>

        <Route path="all-post-jobs/:jobID" element={<SinglePostJobPage />} />

        <Route path="*" element={<Error />} />
      </Route>
    </Routes>
  );
};

export default ProtectedRoute;
